import React, { Component, useState, useEffect, useRef,useCallback } from "react";
import styled from "@emotion/styled";
import {
  Paper,
  Typography,
  Box,
  TextField,
  FormControl,
  InputLabel,
  IconButton,
  MenuItem,
  Button,
  LinearProgress,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Card,
  CardContent,
  OutlinedInput,
  Checkbox,
  ListItemText,FormControlLabel
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";



import imageCompression from 'browser-image-compression';



import { Modal } from "@mui/joy";


import { useSelector } from "react-redux";
import { useFetch, useDelete, useUpdate,useFetchById } from "../../hooks";
import { urls } from "../../urls/urls";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { SnackBarComponent } from "../../components";


const StyledPaper = styled(Paper)({
  padding: "16px",
  border: "1px solid #ddd",
  borderRadius: "4px",
  backgroundColor: "#fff",
});

const ImageItem = ({ name, error, onRemove }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      p: 1,
      border: "1px solid #ddd",
      borderRadius: "4px",
    }}
  >
    <img
      src={name}
      alt="Product thumbnail"
      style={{
        width: "50px",
        height: "50px",
        marginRight: "8px",
        objectFit: "cover",
      }}
    />
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="body2" color="textSecondary">
        {name}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={100}
        sx={{
          height: "6px",
          borderRadius: "2px",
          mt: 1,
          backgroundColor: "inherit",
          "& .MuiLinearProgress-bar": {
            backgroundColor: error ? "red" : "green",
          },
        }}
      />
    </Box>

    <IconButton onClick={onRemove} sx={{ ml: 1 }}>
      <CloseIcon />
    </IconButton>
  </Box>
);

const ProductFormAdmin = ({ onBack,showSnackBar,data,isEditing,onModalOpen }) => {

console.log("menudataform",data)
  const [snackbarState, setSnackbarState] = useState({
      open: false,
      severity: 'success', // Default severity 
      message: '',
      position: { vertical: 'top', horizontal: 'center' },
    });
  const loginToken=useSelector((state)=>state.user.logintoken)
  const [errorMessage, setErrorMessage] = useState(null);

  const [salesStart, setSalesStart] = useState(null);
  const [salesEnd, setSalesEnd] = useState(null);
  const [taxStatus, setTaxStatus] = useState("taxable"); //
  const imageInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [addSubCategoryModal, setAddSUbCategoryModal] = useState(false);
  const [categoriesData, setCategoriesData] = useState([]);
  const [subCategoriesData, setSubCategoriesData] = useState([]);
  const [variantSubCatData, setVariantSubCatData] = useState([]);
  const [variantOptionsResults, setVariantOptionsResult] = useState([]);

  
const [selectedVariants, setSelectedVariants] = useState([]); // New state for selections
  const [optionsMap, setOptionsMap] = useState({});
  const [badgeData, setBadgeData] = useState([]);
  const [ribbonDataArray, setRibbonData] = useState([]);
  const [brandsDataArray, setBrandData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [weight, setWeight] = useState([]);
  const [color, setColor] = useState([]);
  const [size, setSize] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  // const [formValues, setFormValues] = useState({
  //   category_id: "",
  //   sub_cat_id: "",
  //   product_name: "",
  //   price: "",
  //   badge_name: "",
  //   ribbon_name: "",
  //   brand_name: "",
  //   variants_selected: "",
  //   images: "",
    
  // });
const [formErrors, setFormErrors] = useState({});
  const getInitialFormValues = () => ({
    product_id:isEditing? data.product_id : "",
    category_id: isEditing ? data.category_id : "",
    sub_cat_id: isEditing ? data.sub_cat_id : "",
    product_name: isEditing ? data?.name || '' : '',
    price: isEditing ? data.regularPrice : "",
    badge_name: isEditing ? data.badge_id : "",
    ribbon_name: isEditing ? data.ribbon_id : "",
    brand_name: isEditing ? data.brand_id : "",
    variants_selected: isEditing ? data.variantData : "",
    images: isEditing? data.images:"",
  });

  const [formValues, setFormValues] = useState(getInitialFormValues());
  const [imageId, setImageId] = useState();
  


  useEffect(()=>{
    fetchData()
    // fetchSubCategory()
    fetchBrandsData()
    fetchRibbonData()
  },[])

  const fetchOptions = useFetch('', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });


const validateForm = () => {
  const errors = {};

  if (!formValues.category_id) {
    errors.category_id = "Please select a category";
  }
  if (!formValues.sub_cat_id) {
    errors.sub_cat_id = "Please select a sub-category";
  }
  if (!formValues.product_name || !formValues.product_name.trim()) {
    errors.product_name = "Product name is required";
  }
  if (!formValues.price || Number(formValues.price) <= 0) {
    errors.price = "Please enter a valid price";
  }
  // Only require new images when creating (not when editing an item that already has images)
  const hasExistingImages = Array.isArray(formValues.images) && formValues.images.length > 0;
  if (selectedFiles.length === 0 && !hasExistingImages) {
    errors.images = "Please upload at least one image";
  }

  setFormErrors(errors);
  return Object.keys(errors).length === 0;
};

  useEffect(()=>{
    
      const catByIdUrl = urls("findByCatId",formValues['category_id']);
      console.log("catByIdUrl",catByIdUrl)
      console.log("catByIdUrl",formValues)
      if(formValues['category_id'])
      {
        fetchSubCategory(catByIdUrl);
      }else if(data && data.category_id)
      {
        const catByIdUrl = urls("findByCatId",data.category_id);
        fetchSubCategory(catByIdUrl);
      }
        
    
  },[formValues['category_id'] || data.category_id])
  
  useEffect(()=>{
    
      const subCatByVIdUrl = urls("getVariantBySubCatID",formValues['sub_cat_id']);
      console.log("subCatByVIdUrl",subCatByVIdUrl)
      console.log("subCatByVIdUrl",formValues['subcategory'])
      if(formValues['sub_cat_id'])
      {
        fetchVarinatIdSubCategory(subCatByVIdUrl);
      }
        
    
  },[formValues['sub_cat_id']])


                  // Categories
      const {data:categoryData,isLoading,error,fetchData} = useFetch(BASE_URL_TEST+urls('getAllCategories'),{
                    method: 'GET',
                    headers: { 
                        'Content-Type': 'application/json',
                        "Authorization":loginToken ? `Bearer ${loginToken}`:''
                    }
                  })


                   // SubCategoreis

                    const {data:subCategoryData,error:subCategoryError,fetchDataById:fetchSubCategory} = useFetchById(BASE_URL_TEST,{
                                    method: 'GET',
                                    headers: { 
                                        'Content-Type': 'application/json',
                                        "Authorization":loginToken ? `Bearer ${loginToken}`:''
                                    }
                                  })

                                  // Variant BySubCat ID
                                  const {data:varinatIdSubCategoryData,error:varinatIdSubCategoryError,fetchDataById:fetchVarinatIdSubCategory} = useFetchById(BASE_URL_TEST,{
                                    method: 'GET',
                                    headers: { 
                                        'Content-Type': 'application/json',
                                        "Authorization":loginToken ? `Bearer ${loginToken}`:''
                                    }
                                  })


                      // Bfrnads

                      const {
                          data: brandsData,
                          
                          error:brandsError,
                          fetchData:fetchBrandsData,
                        } = useFetch(BASE_URL_TEST + urls("getAllBrands"), {
                          method: "GET",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: loginToken ? `Bearer ${loginToken}` : "",
                          },
                        });

                        // Ribbon
                           const {data:ribbonData,error:ribbonDataError,fetchData:fetchRibbonData} = useFetch(BASE_URL_TEST+urls('getAllRibbons'),{
                                method: 'GET',
                                headers: { 
                                    'Content-Type': 'application/json',
                                    "Authorization":loginToken ? `Bearer ${loginToken}`:''
                                }
                              })



                               // Create Product
                           const {data:productData,error:productDataError,fetchData:fetchCreateProduct} = useFetch(BASE_URL_TEST+urls('createProducts'),{
                            method: 'POST',
                            headers: { 
                              
                                "Authorization":loginToken ? `Bearer ${loginToken}`:''
                            }
                          })


                          // Update Product
                           const {data:updatedProductData,error:updatedProductError,updateData:fetchUpdateData} = useUpdate(BASE_URL_TEST,{
                                            method: 'PUT',
                                            headers: { 
                                              
                                                "Authorization":loginToken ? `Bearer ${loginToken}`:''
                                            }
                                          })

                                              //  Delete Images
                                                const {
                                                  data: deletedProductImageData,
                                                  error: deletedProductImageError,
                                                  deleteData: fetchDeleteData,
                                                } = useDelete(BASE_URL_TEST, {
                                                  method: "DELETE",
                                                  headers: {
                                                    Authorization: loginToken ? `Bearer ${loginToken}` : "",
                                                  },
                                                });


                                 useEffect(()=>{
                                                if(updatedProductError)
                                                  {
                                              
                                                  }else if(updatedProductData && updatedProductData['status']===true)
                                                  {
                                                    console.log("updatedCategoryData",updatedProductData['data'])
                                                    
                                                    setSnackbarState({...snackbarState,open:true,message:updatedProductData['message'],position:{ vertical: 'top', horizontal: 'center' },severity:'success'})
                                                    setModalOpen(false);
                                                    onBack(false)
                                                    fetchData()
                                                  }
                                
                                              },[updatedProductData,updatedProductError])


                                 useEffect(()=>{
                                                if(deletedProductImageError)
                                                  {
                                              
                                                  }else if(deletedProductImageData && deletedProductImageData['status']===true)
                                                  {
                                               
                                                    
                                                    setSnackbarState({...snackbarState,open:true,message:deletedProductImageData['message'],position:{ vertical: 'top', horizontal: 'center' },severity:'success'})
                                                   
                                  
                                                    setFormValues((prev) => ({
                                                      ...prev,
                                                      images: prev.images.filter((img) => img.p_image_id !== imageId),
                                                    }));
                                                  }
                                
                                              },[deletedProductImageData,deletedProductImageData])


                          // const handleCheckboxChange = (variant, option) => {
                          //   console.log('vname and option',variant,option)
                          //   setSelectedOptions((prev) => {
                          //     const variantOptions = prev[variant] || [];
                          //     const updatedOptions = variantOptions.includes(option)
                          //       ? variantOptions.filter((opt) => opt !== option)
                          //       : [...variantOptions, option];
                        
                          //     return { ...prev, [variant]: updatedOptions };
                          //   });
                          // };


                          // const handleCheckboxChange = (variantName, optionName, item) => {
                          //   console.log('handleCheckboxChange called with:', { variantName, optionName, item });
                          //   const selectedOptionDetails = item.options.find(
                          //     option => option.option_name === optionName
                          //   );
                          
                          //   setSelectedOptions(prevState => {
                          //     // Create a deep copy of the previous state to avoid mutation
                          //     const newState = JSON.parse(JSON.stringify(prevState));
                              
                          //     // Find the relevant variant in our state
                          //     const variantIndex = newState.findIndex(
                          //       variant => variant.variant_id === item.variant_id
                          //     );
                          
                          //     if (variantIndex === -1) {
                          //       // If the variant doesn't exist in our state, we'll add it
                               
                          //       return [
                          //         ...newState,
                          //         {
                          //           variant_id: item.variant_id,
                          //           title: variantName,
                          //           options: [{
                          //             variant_option_id: selectedOptionDetails.variant_option_id,
                          //             option_name: optionName
                          //           }]
                          //         }
                          //       ];
                          //     }
                          
                          //     // Check if this option is already selected in this variant
                          //     const existingOptionIndex = newState[variantIndex].options.findIndex(
                          //       option => option.variant_option_id === selectedOptionDetails.variant_option_id
                          //     );
                          
                          //     if (existingOptionIndex === -1) {
                             
                          //       newState[variantIndex].options.push({
                          //         variant_option_id: selectedOptionDetails.variant_option_id,
                          //         option_name: optionName
                          //       });
                          //     } else {
                          //       // Option already selected - remove it
                          //       newState[variantIndex].options.splice(existingOptionIndex, 1);
                          //     }
                             
                              
                          //     return newState;
                          //   });
                          // };

                          const handleCheckboxChange = (variantName, optionName, item) => {
                            console.log("Checkbox clicked:", { variantName, optionName, item });
                            console.log("Current selectedOptions before change:", selectedOptions);
                            
                            if (!item || !item.options) {
                              console.error('Invalid item or missing options:', item);
                              return;
                            }
                               
                            const selectedOptionDetails = item.options.find(
                              option => option.option_name === optionName
                            );
                          
                            if (!selectedOptionDetails) {
                              console.error(`Option "${optionName}" not found in item:`, item);
                              return;
                            }
                          
                            setSelectedOptions(prevState => {
                              
                              const newState = JSON.parse(JSON.stringify(prevState || []));
                              console.log("Previous state in setter:", newState);
                              
                              
                              const variantIndex = newState.findIndex(
                                variant => variant.variant_id === item.variant_id
                              );
                          
                              let updatedState;
                              if (variantIndex === -1) {
                                
                                updatedState = [
                                  ...newState,
                                  {
                                    variant_id: item.variant_id,
                                    title: variantName,
                                    options: [{
                                      variant_option_id: selectedOptionDetails.variant_option_id,
                                      option_name: optionName
                                    }]
                                  }
                                ];
                              } else {
                                
                                const existingOptionIndex = newState[variantIndex].options.findIndex(
                                  option => option.variant_option_id === selectedOptionDetails.variant_option_id
                                );
                          
                                if (existingOptionIndex === -1) {
                                  
                                  newState[variantIndex].options.push({
                                    variant_option_id: selectedOptionDetails.variant_option_id,
                                    option_name: optionName
                                  });
                                } else {
                                  
                                  newState[variantIndex].options.splice(existingOptionIndex, 1);
                                  
                                  
                                  if (newState[variantIndex].options.length === 0) {
                                    newState.splice(variantIndex, 1);
                                  }
                                }
                                updatedState = newState;
                              }
                              
                              console.log("Updated state after change:", updatedState);
                              return updatedState;
                            });
                            
                            
                            setTimeout(() => {
                              console.log("selectedOptions after update:", selectedOptions);
                            }, 0);
                          };
                        console.log("selectedOptions",selectedOptions);
                     

                  

   // Categoreis useEffect
           useEffect(()=>{
                        if(error)
                          {
                      
                          }else if(categoryData && categoryData['status']===true)
                          {
                            console.log("categoryData product",categoryData['data'])
                         setCategoriesData(categoryData['data'])
                           
                          }
                      
        
                      },[categoryData,error])



                        // SubCategoreis useEffect
           useEffect(()=>{
            if(subCategoryError)
              {
          
              }else if(subCategoryData && subCategoryData['status']===true)
              {
                console.log("categoryData product",subCategoryData['data'])
             setSubCategoriesData(subCategoryData['data'])
               
              }
          

          },[subCategoryData,subCategoryError])


                        // Brands useEffect
           useEffect(()=>{
            if(brandsError)
              {
          
              }else if(brandsData && brandsData['status']===true)
              {
                console.log("brandsData product",brandsData['data'])
             setBrandData(brandsData['data'])
               
              }
          

          },[brandsData,brandsError])



              // Ribbbons useEffect
              useEffect(()=>{
                if(ribbonDataError)
                  {
              
                  }else if(ribbonData && ribbonData['status']===true)
                  {
                    console.log("brandsData product",ribbonData['data'])
                 setRibbonData(ribbonData['data'])
                   
                  }
              
    
              },[ribbonData,ribbonDataError])

              // productData useEffect
              useEffect(()=>{
                if(productDataError)
                  {
              
                  }else if(productData && productData['status']===true)
                  {
                    console.log("productData product",productData)
                    setSnackbarState({...snackbarState,open:true,message:productData['message'],position:{ vertical: 'top', horizontal: 'center' },severity:'success'})
                    setModalOpen(false);
                    onBack(false)
                    showSnackBar(true)
                    onModalOpen(false)
                    // handleMenuClose();
                    // fetchData()
                //  setRibbonData(productData['data'])
                   
                  }
              
    
              },[productData,productDataError])


              // Varians by SubCatID useEffect
              useEffect(()=>{
                if(varinatIdSubCategoryError)
                  {
              
                  }else if(varinatIdSubCategoryData && varinatIdSubCategoryData['status']===true)
                  {
                    console.log("varinatIdSubCategoryData product",varinatIdSubCategoryData['data'])
                     
                 setVariantSubCatData(varinatIdSubCategoryData['data'])
                   
                  }
              
    
              },[varinatIdSubCategoryData,varinatIdSubCategoryError])



              // Process the variant data and calling api based on variantId
              useEffect(()=>{
                processVariants()

              },[variantSubCatData])





// When fetching a single product for editing (using product_id)
useEffect(() => {
  if (isEditing && data['product_id']) {
    // Fetch product data by ID
    fetch(`${BASE_URL_TEST}/api/pcatalog/findById/${data['product_id']}`, {
      headers: {
        'Authorization': `Bearer ${loginToken}`
      }
    })
    .then(response => response.json())
    .then(result => {
      if (result.status && result.data) {
        // Set product data for form fields
        // setFormData({
        //   category_id: result.data.category_id,
        //   sub_cat_id: result.data.sub_cat_id,
        //   brand_id: result.data.brand_id,
        //   name: result.data.name,
        //   description: result.data.description,
        //   badge_id: result.data.badge_id,
        //   ribbon_id: result.data.ribbon_id,
        //   regularPrice: result.data.regularPrice,
        //   salePrice: result.data.salePrice,
        //   // other fields...
        // });
        
        // Set the selected variant options
        if (result.data.variantData) {
          setSelectedOptions(result.data.variantData);
          console.log("Set selected variants:", result.data.variantData);
        }
      }
    })
    .catch(error => {
      console.error("Error fetching product details:", error);
    });
  }
}, [isEditing, data['product_id']]);

            //   async function processVariants() {
            //     const results = [];
            //     for (const variant of variantSubCatData) {
            //         try {
            //             const options = await fetchVariantOptions(variant.variant_id);
            
                      
            //             const uniqueOptions = [...new Set(options.map(option => option.option_name))];
            
                        
            //             results.push({
            //                 variant_name: variant.title,
            //                 options: uniqueOptions
            //             });
            //         } catch (error) {
            //             console.error(`Failed to fetch data for variant_id ${variant.variant_id}:`, error);
            //         }
            //     }
            
            //     console.log("results",results);
            //     setVariantOptionsResult(results);
            // }

            function renderVariantOptions() {
              if (!variantOptionsResults || variantOptionsResults.length === 0) {
                return <Typography>No variant options available</Typography>;
              }
            
              return variantOptionsResults.map(item => (
                <div key={item.variant_id} className="variant-group">
                  <Typography variant="h6">{item.variant_name}</Typography>
                  
                  {item.options.length > 0 ? (
                    item.options.map((option) => {
                      // Find if this variant exists in our selected options
                      const selectedVariant = selectedOptions.find(
                        variant => variant.variant_id === item.variant_id
                      );
                      
                      // Check if this specific option is selected
                      const isSelected = selectedVariant?.options.some(
                        selected => selected.variant_option_id === option.variant_option_id
                      );
            
                      return (
                        <FormControlLabel
                          key={option.variant_option_id}
                          control={
                            <Checkbox
                              checked={isSelected || false}
                              onChange={() => handleCheckboxChange(item.variant_name, option.option_name, item)}
                            />
                          }
                          label={option.option_name}
                        />
                      );
                    })
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      No options available
                    </Typography>
                  )}
                </div>
              ));
            }


            async function processVariants() {
              const results = [];
              console.log("variantSubCatData",variantSubCatData)
              for (const variant of variantSubCatData) {
                  try {
                      const options = await fetchVariantOptions(variant.variant_id);
                      
                      results.push({
                          variant_name: variant.title,
                          variant_id: variant.variant_id,
                          options: options.map(option => ({
                              variant_option_id: option.variant_option_id,
                              option_name: option.option_name,
                              status: option.status,
                              variant_id: option.variant_id,
                              variant_name: option.variant_name
                          }))
                      });
                  } catch (error) {
                      console.error(`Failed to fetch data for variant_id ${variant.variant_id}:`, error);
                  }
              }
          
              console.log("results", results);
              setVariantOptionsResult(results);
          }


            // Function to get bariant optisn based on vid
async function fetchVariantOptions(variantId) {
  const response = await fetch(`${BASE_URL_TEST}/api/voptions/findByVariantId/${variantId}`,{
    method: 'GET',
    headers: { 
        'Content-Type': 'application/json',
        "Authorization":loginToken ? `Bearer ${loginToken}`:''
    }
  });
  if (!response.ok) {
      throw new Error(`Error fetching data for variant_id: ${variantId}`);
  }
  const data = await response.json();
  console.log("varianoptinds data",data)
  return data.data; 
}

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };


  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("formvalues dropdown",name,value)

    const nameToFormKey = {
      subcategory: 'sub_cat_id',
      category: 'category_id',

     
    };
    const formKey = nameToFormKey[name] || name;
    // setFormValues((prevValues) => ({
    //   ...prevValues,
    //   [name]: value,
    // }));

    setFormValues((prevValues) => {
      const newValues = {
        ...prevValues,
        [formKey]: value,
      };
      return newValues;
    });
  };

  

  const handleImageChange = (event) => {

    const files = event.target.files;
    const validFiles = [];
    const errors = [];

    if (files) {
      if (selectedFiles.length + files.length > 4) {
        setErrorMessage("You can only upload up to 4 images.");
        return;
      }

      Array.from(files).forEach((file) => {
        if (file.type === "image/jpeg" || file.type === "image/png") {
          validFiles.push(file);
        } else {
          errors.push(
            "${file.name} is not a valid image. Only .jpg and .png are allowed."
          );
        }
      });

      if (errors.length > 0) {
        setErrorMessage(errors.join(", "));
      } else {
        setErrorMessage(null);
      }

      setSelectedFiles((prev) => [...prev, ...validFiles]);
    }
    
  };

  const handleClearForm = () => {
  setFormValues(getInitialFormValues());
  setSelectedFiles([]);
  setSelectedOptions([]);
  setErrorMessage(null);
};

const handleCancel = () => {
  onBack(false);
}; 
  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    console.log("filebnn", file);
    if (file) {
      setSelectedFile(file);
      setSuccessMessage(null);
    }
  };

  const removeImageFromForm = (id) => {
    console.log("iamgeid",id)
    setImageId(id)
        const deleteUrl = urls("deleteProductImage", id);
        fetchDeleteData(deleteUrl);
  
  };

  const handleAddProduct = () => {
    setAddCategoryModal(!addCategoryModal);
    console.log("selectedFiles",selectedFiles)
    console.log("formValues",formValues)
  };

  const handleAddSubCateogry = () => {
    setAddSUbCategoryModal(!addSubCategoryModal);
  };
  const handleAddCategoryClose = () => {
    setAddCategoryModal(false);
    // setOpen(false)
  };
  const handleAddSubCategoryClose = () => {
    setAddSUbCategoryModal(false);
    // setOpen(false)
  };

  const [tableData, setTableData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const colorOptions = ["Red", "Blue", "Green", "Yellow", "Black", "White"];
  const handleAddVariant = () => {
    // Add form values to the table and reset the form
    setTableData([...tableData, formValues]);
    setFormValues({ category3: "", category4: [], category5: "" });
    setModalOpen(false);
  };
  const handleCreateProduct = async () => {
     if (!validateForm()) {
    setSnackbarState({
      ...snackbarState,
      open: true,
      message: "Please fill in all required fields",
      position: { vertical: "top", horizontal: "center" },
      severity: "error",
    });
    return;
  }
    setAddCategoryModal(!addCategoryModal);
    console.log("formvalues selectedOptions",selectedOptions);
    if(isEditing)
    {

      console.log("formvalues produpdate",formValues);
      console.log("formvalues selectedOptions",selectedOptions);

       const updateUrl = urls('updateProduct', formValues['product_id']); 
       const formdata = new FormData();
       formdata.append("category_id", formValues["category_id"]);
       formdata.append("sub_cat_id", formValues["sub_cat_id"]);
       formdata.append("name", formValues["product_name"]);
       formdata.append("description", "mobile");
if (formValues["badge_name"]) {
  formdata.append("badge_id", formValues["badge_name"]);
}
if (formValues["ribbon_name"]) {
  formdata.append("ribbon_id", formValues["ribbon_name"]);
}
if (formValues["brand_name"]) {
  formdata.append("brand_id", formValues["brand_name"]);
}
       formdata.append("regularPrice",formValues['price']);
       formdata.append("variantData", selectedOptions ? JSON.stringify(selectedOptions) : "");
       formdata.append("salePrice", formValues['price']);
       for (const file of selectedFiles) {
        const compressedFile = await compressImage(file);
        formdata.append("images", compressedFile);
      }
          fetchUpdateData(updateUrl,formdata)
         
    }
    else{
      console.log("formValuesData",formValues)
      const formdata = new FormData();
      formdata.append("category_id", formValues["category_id"]);
      formdata.append("sub_cat_id", formValues["sub_cat_id"]);
      formdata.append("brand_id", formValues["brand_name"]);
      formdata.append("name", formValues["product_name"]);
      formdata.append("description", "mobile");
      formdata.append("badge_id", formValues["badge_name"]);
      formdata.append("ribbon_id",formValues["ribbon_name"]);
      formdata.append("regularPrice",formValues['price']);
      // formdata.append("variantData", JSON.stringify([{"variant_id":6,"title":"Colors","options":[{"variant_option_id":28,"option_name":"red"},{"variant_option_id":29,"option_name":"green"},{"variant_option_id":32,"option_name":"black"},{"variant_option_id":33,"option_name":"orange"}]},{"variant_id":10,"title":"type","options":[{"variant_option_id":42,"option_name":"heat"},{"variant_option_id":43,"option_name":"human"}]}]) );
      formdata.append("variantData", JSON.stringify(selectedOptions) );
      formdata.append("salePrice", formValues['price']);
    
      // Compress and append images
      for (const file of selectedFiles) {
        const compressedFile = await compressImage(file);
        formdata.append("images", compressedFile);
      }
    
      fetchCreateProduct(formdata);

    }
   
  };

  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 1, 
      maxWidthOrHeight: 1920, 
      useWebWorker: true,
    };
    try {
      return await imageCompression(file, options);
    } catch (error) {
      console.error('Error compressing image:', error);
      return file;
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };


  const VariantOptions = ({variantOptionsResult,optionsData}) => {

    const [selectedOptions, setSelectedOptions] =useState([]);

    // const updateOptionsData = useCallback(() => {
    //   if (selectedOptions.length > 0) {
    //     optionsData(selectedOptions);
    //   }
    // }, [selectedOptions, optionsData]);
  
    // // Use useEffect to handle updates to parent
    // useEffect(() => {
    //   updateOptionsData();
    // }, [updateOptionsData]);

    const handleCheckboxChange = (variantName, optionName, item) => {
     
      const selectedOptionDetails = item.options.find(
        option => option.option_name === optionName
      );
    
      setSelectedOptions(prevState => {
        // Create a deep copy of the previous state to avoid mutation
        const newState = JSON.parse(JSON.stringify(prevState));
        
        // Find the relevant variant in our state
        const variantIndex = newState.findIndex(
          variant => variant.variant_id === item.variant_id
        );
    
        if (variantIndex === -1) {
          // If the variant doesn't exist in our state, we'll add it
          // This shouldn't happen if state is initialized properly, but good to handle
          return [
            ...newState,
            {
              variant_id: item.variant_id,
              title: variantName,
              options: [{
                variant_option_id: selectedOptionDetails.variant_option_id,
                option_name: optionName
              }]
            }
          ];
        }
    
        // Check if this option is already selected in this variant
        const existingOptionIndex = newState[variantIndex].options.findIndex(
          option => option.variant_option_id === selectedOptionDetails.variant_option_id
        );
    
        if (existingOptionIndex === -1) {
       
          newState[variantIndex].options.push({
            variant_option_id: selectedOptionDetails.variant_option_id,
            option_name: optionName
          });
        } else {
          // Option already selected - remove it
          newState[variantIndex].options.splice(existingOptionIndex, 1);
        }
       
       
        // return newState;
      });
    };
    // optionsData(selectedOptions)
    console.log("selectedOptions checkbox",selectedOptions)
  
    return (
  <div></div>
    );
  };



  return (
    <Box sx={{ display: "flex", gap: 2, width: "100%" }}>

         <SnackBarComponent
                open={snackbarState.open}
                onClose={handleSnackbarClose}
                severity={snackbarState.severity}
                message={snackbarState.message}
                position={snackbarState.position}
              />
      <StyledPaper sx={{ width: "65%", marginTop: 2 }}>
        {/* Product Category  */}
        <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom>
              Product Category
            </Typography>
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <Select
                labelId="productid-label"
                id="productid"
                name="category"
                value={formValues.category_id}
                onChange={handleInputChange}
                variant="outlined"
              >
                  {categoriesData && categoriesData.map((category) => (
                                                <MenuItem key={category.category_id} value={category.category_id}>
                                                  {category.name}
                                                </MenuItem>
                                              ))}
              </Select>
              {formErrors.category_id && (
    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1 }}>
      {formErrors.category_id}
    </Typography>
  )}
            </FormControl>
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom>
              Product Sub-Category
            </Typography>
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <Select
                labelId="subcategory"
                id="subcategory"
                  name="subcategory"
                value={formValues.sub_cat_id}
                onChange={handleInputChange}
                variant="outlined"
              >
                {subCategoriesData && subCategoriesData.map((category) => (
                                                <MenuItem key={category.sub_cat_id} value={category.sub_cat_id}>
                                                  {category.name}
                                                </MenuItem>
                                              ))}
              </Select>
            </FormControl>
          </Box>
        </Box>

        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" gutterBottom>
            Product Name
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            value={formValues.product_name || ''}
            onChange={(e) => {
    setFormValues({ ...formValues, product_name: e.target.value });
    if (formErrors.product_name) setFormErrors({ ...formErrors, product_name: undefined });
  }}
  error={!!formErrors.product_name}
  helperText={formErrors.product_name}
  sx={{ mb: 2 }}
          />
        </Box>

        <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom>
              Regular Price
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              value={formValues.price}
               onChange={(e) => {
    setFormValues({ ...formValues, price: e.target.value });
    if (formErrors.price) setFormErrors({ ...formErrors, price: undefined });
  }}
  error={!!formErrors.price}
  helperText={formErrors.price}
  sx={{ mb: 2 }}
            />
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom>
              Badge
            </Typography>
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <Select
                labelId="sku-label"
                id="sku"
                value={formValues.badge_name}
                onChange={(e) =>
                  setFormValues({ ...formValues, badge_name: e.target.value })
                }
                variant="outlined"
              >
                 {/* {brandsDataArray && brandsDataArray.map((category) => (
                                                <MenuItem key={category.brand_id} value={category.brand_id}>
                                                  {category.name}
                                                </MenuItem>
                                              ))} */}

{ribbonDataArray && ribbonDataArray.map((category) => {
    if(category.type === 'badge') {
        return (
            <MenuItem key={category.badge_id} value={category.badge_id}>
                {category.name}
            </MenuItem>
        );
    }
    return null; 
})}
              </Select>
            </FormControl>
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom>
              Ribbons
            </Typography>
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <Select
                labelId="imageid-label"
                id="imageid"
                value={formValues.ribbon_name}
                onChange={(e) =>
                  setFormValues({ ...formValues, ribbon_name: e.target.value })
                }
                variant="outlined"
              >
               {ribbonDataArray && ribbonDataArray.map((category) => {
    if(category.type === 'ribbon') {
        return (
            <MenuItem key={category.badge_id} value={category.badge_id}>
                {category.name}
            </MenuItem>
        );
    }
    return null; 
})}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom>
              Brand Name
            </Typography>
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <Select
                labelId="discount-label"
                id="discount"
                value={formValues.brand_name}
                onChange={(e) =>
                  setFormValues({ ...formValues, brand_name: e.target.value })
                }
                variant="outlined"
              >
               {brandsDataArray && brandsDataArray.map((category) => (
                                                <MenuItem key={category.brand_id} value={category.brand_id}>
                                                  {category.name}
                                                </MenuItem>
                                              ))}
              </Select>
            </FormControl>
          </Box>
        </Box>

        <Card sx={{ p: 2, boxShadow: 3 }}>
          <CardContent>
            {/* Header Section */}
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h6" gutterBottom>
                Product Variants
              </Typography>
            </Box>
{renderVariantOptions()}
          </CardContent>
        </Card>

        <Box
          display="flex"
          gap={2}
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            mt: 3,
          }}
        >
          {/* CREATE  Button */}
          <Button
            variant="contained"
            sx={{
              bgcolor: "#006d6d",
              color: "#fff",
              "&:hover": { bgcolor: "#005454" },
              fontWeight: "bold",
            }}
            onClick={handleCreateProduct}
            // onClick={handleAddProduct}
          >
            {isEditing ? 'Update' :'CREATE' }
          </Button>

          {/* CLEAR Button */}
        {/* CLEAR Button */}
<Button
  variant="outlined"
  sx={{
    borderColor: "red",
    color: "red",
    fontWeight: "bold",
    "&:hover": { borderColor: "darkred", color: "darkred" },
  }}
  onClick={handleClearForm}
>
  CLEAR
</Button>

{/* CANCEL Button */}
<Button
  variant="outlined"
  sx={{
    borderColor: "black",
    color: "black",
    fontWeight: "bold",
    "&:hover": { borderColor: "grey", color: "grey" },
  }}
  onClick={handleCancel}
>
  CANCEL
</Button>
        </Box>
      </StyledPaper>
      <Box sx={{ width: "35%", marginTop: 2 }}>
        <StyledPaper sx={{ mb: 2, textAlign: "center" }}>
          {selectedFiles.length > 0 ? (
            <img
              src={URL.createObjectURL(selectedFiles[0])}
              alt="Product"
              style={{ width: "80%" }}
            />
          ) : (
            <img
              src="/placeholder.jpg"
              alt="Placeholder"
              style={{ width: "80%" }}
            />
          )}
        </StyledPaper>

        <StyledPaper>
          <Typography variant="h6" gutterBottom>
            Product Gallery
          </Typography>
          <Box
            sx={{
              border: "2px dashed #ddd",
              borderRadius: "4px",
              p: 2,
              textAlign: "center",
              mb: 2,
              cursor: "pointer",
            }}
            onClick={() => imageInputRef.current?.click()}
          >
            <img
              src="/ph_image-light.svg"
              alt="Product"
              style={{ width: "20%" }}
            />
            <Typography variant="body1" color="textSecondary">
              Drop your imagesss here, or browse
            </Typography>
            <Typography variant="body2" color="textSecondary">
              500x500 KB Jpeg, png are allowed
            </Typography>
            <input
              type="file"
              accept="image/jpeg, image/png"
              multiple
              ref={imageInputRef}
              style={{ display: "none" }}
              onChange={handleImageChange}
            />
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {selectedFiles.map((file, index) => (
              <ImageItem
                key={index}
                name={URL.createObjectURL(file)}
                error={file.type !== "image/jpeg" && file.type !== "image/png"}
                onRemove={() => {
                  setSelectedFiles((prevFiles) =>
                    prevFiles.filter((_, i) => i !== index)
                  );
                }}
              />
            ))}
            {console.log("imagetye",formValues.images)}

            {formValues && Array.isArray(formValues.images)
  ? formValues.images.map((item) => (
      <Box
        key={item.p_image_id} // Use a unique key from your data if available
        sx={{
          display: "flex",
          alignItems: "center",
          p: 1,
          border: "1px solid #ddd",
          borderRadius: "4px",
        }}
      >
        <img
          src={item.image_url} // Use the dynamic image_url from your data
          alt="Product thumbnail"
          style={{
            width: "50px",
            height: "50px",
            marginRight: "8px",
            objectFit: "cover",
          }}
        />
        <IconButton sx={{ ml: 1 }}   onClick={() => removeImageFromForm(item.p_image_id)}>
          <CloseIcon />
        </IconButton>
      </Box>
    ))
  : null}
          </Box>

          {errorMessage && (
            <Typography
              variant="body2"
              sx={{ mt: 2, color: "red", fontWeight: "bold" }}
            >
              {errorMessage}
            </Typography>
          )}
        </StyledPaper>

        <Box sx={{ display: "none", justifyContent: "space-between", mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ width: "32%" }}
            onClick={handleAddProduct}
          >
            UPDATE
          </Button>
          <Button variant="contained" color="error" sx={{ width: "32%" }}>
            DELETE
          </Button>
          <Button
            variant="contained"
            color="inherit"
            sx={{ width: "32%" }}
            onClick={onBack}
          >
            CANCEL
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
export default ProductFormAdmin;
